module.exports = __webpack_public_path__ + "img/Europe.920bf8b.webp";